<div class="wrapper">
    <div class="maxwidth">
        <h4 class="title tipo-second-color bold">{{ "PRIVATE.COMPANY.FILE-COMPANY.TITLE" | translate }} </h4>       
        <app-data-company [inEdit]="true" [isFieldsDisabled]="true" [his]="his"></app-data-company>        
    </div>
</div>
